/**
* © 2025. The EGT Universe. All Rights Reserved.
* License: Requires ACTIVE AppArtisan Subscription.
* Generated: Auto generated by Universe App Tools.
* 
* Namespace: scripto
* Filename: fields
* Description: All the fields for the app.
*/

var registry = require("../uam/registry.js");
var _myRegistry = registry("uam.includes.fields");

var $ = {};
$.access = require("../fields/access.js");

_myRegistry.add($.access);
$.any = require("../fields/any.js");

_myRegistry.add($.any);
$.appid = require("../fields/appid.js");

_myRegistry.add($.appid);
$.attr = {};
$.attr.default = require("../fields/attr.default.js");

_myRegistry.add($.attr.default);
$.attr.list = require("../fields/attr.list.js");

_myRegistry.add($.attr.list);
$.attr.name = require("../fields/attr.name.js");

_myRegistry.add($.attr.name);
$.attr.namespace = require("../fields/attr.namespace.js");

_myRegistry.add($.attr.namespace);
$.attr.required = require("../fields/attr.required.js");

_myRegistry.add($.attr.required);
$.boolean = require("../fields/boolean.js");

_myRegistry.add($.boolean);
$.class = require("../fields/class.js");

_myRegistry.add($.class);
$.class = {};
$.class.tokens = require("../fields/class.tokens.js");

_myRegistry.add($.class.tokens);
$.color = require("../fields/color.js");

_myRegistry.add($.color);
$.crossorigin = require("../fields/crossorigin.js");

_myRegistry.add($.crossorigin);
$.dashboard = {};
$.dashboard.schema = require("../fields/dashboard.schema.js");

_myRegistry.add($.dashboard.schema);
$.date = require("../fields/date.js");

_myRegistry.add($.date);
$.datetime = require("../fields/datetime.js");

_myRegistry.add($.datetime);
$.email = require("../fields/email.js");

_myRegistry.add($.email);
$.guid = require("../fields/guid.js");

_myRegistry.add($.guid);
$.icon = require("../fields/icon.js");

_myRegistry.add($.icon);
$.id = require("../fields/id.js");

_myRegistry.add($.id);
$.image = require("../fields/image.js");

_myRegistry.add($.image);
$.inner = require("../fields/inner.js");

_myRegistry.add($.inner);
$.list = require("../fields/list.js");

_myRegistry.add($.list);
$.namespace = require("../fields/namespace.js");

_myRegistry.add($.namespace);
$.noattr = {};
$.noattr.number = require("../fields/noattr.number.js");

_myRegistry.add($.noattr.number);
$.noattr.string = require("../fields/noattr.string.js");

_myRegistry.add($.noattr.string);
$.number = require("../fields/number.js");

_myRegistry.add($.number);
$.object = require("../fields/object.js");

_myRegistry.add($.object);
$.propertyname = require("../fields/propertyName.js");

_myRegistry.add($.propertyname);
$.referrerpolicy = require("../fields/referrerpolicy.js");

_myRegistry.add($.referrerpolicy);
$.string = require("../fields/string.js");

_myRegistry.add($.string);
$.style = require("../fields/style.js");

_myRegistry.add($.style);
$.time = require("../fields/time.js");

_myRegistry.add($.time);
$.uanamespace = require("../fields/uanamespace.js");

_myRegistry.add($.uanamespace);
$.universe = {};
$.universe.namespace = require("../fields/universe.namespace.js");

_myRegistry.add($.universe.namespace);
$.uri = require("../fields/uri.js");

_myRegistry.add($.uri);


$._ = {
    // namespace: "uri",
registry: _myRegistry,

};
module.exports = $;
